import React from 'react';
import { motion } from 'framer-motion';
// Els estils estan ara a style.css

const EndScreen = ({ score, onPlayAgain }) => {
  const quintOut = [0.22, 1, 0.36, 1]; // Aproximació de Quintic Out

  return (
    <div className="screen-container">
      <motion.div
        className="end-screen-score-container"
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1, transition: { duration: 0.7, ease: quintOut, delay: 0.2 } }}
      >
        <p className="end-screen-score-label">your score:</p>
        <p className="end-screen-score-value">{score}</p>
      </motion.div>

      <motion.button
        className="screen-button"
        onClick={onPlayAgain}
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1, transition: { duration: 0.7, ease: quintOut, delay: 0.4 } }}
        whileHover={{ scale: 1.05, transition: { type: 'spring', stiffness: 400, damping: 10 } }}
        whileTap={{ scale: 0.95 }}
      >
        <span className="semibold-text">play </span>
        <span className="light-text margin-inside-buttons"> again</span>
      </motion.button>
    </div>
  );
};

export default EndScreen;